import { render, staticRenderFns } from "./RobotActivation.vue?vue&type=template&id=47062aaf&scoped=true"
import script from "./RobotActivation.vue?vue&type=script&lang=js"
export * from "./RobotActivation.vue?vue&type=script&lang=js"
import style0 from "./RobotActivation.vue?vue&type=style&index=0&id=47062aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47062aaf",
  null
  
)

export default component.exports